import i18next from 'i18next';

void i18next.init({
	fallbackLng: 'en',
	debug: false,
	interpolation: {
		escapeValue: false,
	},
});

function parseAmount(amount: string | number): number {
	if (typeof amount === 'number') {
		return amount;
	}
	return Number.parseFloat(amount.replaceAll(',', ''));
}

// formats a number or string as currency
function formatCurrency(amount: number | string, currency = 'USD', options: Intl.NumberFormatOptions = {}) {
	const value = typeof amount === 'string' ? parseAmount(amount) : amount;
	return new Intl.NumberFormat(i18next.language, {
		style: 'currency',
		currency,
		...options,
	}).format(value);
}

// formats a number or string without currency symbol
function formatNumber(amount: number | string, options: Intl.NumberFormatOptions = {}) {
	const value = typeof amount === 'string' ? parseAmount(amount) : amount;
	return new Intl.NumberFormat(i18next.language, {
		useGrouping: true,
		maximumFractionDigits: 2,
		minimumFractionDigits: 2,
		...options,
	}).format(value);
}

function getCurrencySymbol(currency = 'USD'): string {
	return (
		new Intl.NumberFormat(i18next.language, {
			style: 'currency',
			currency,
			currencyDisplay: 'symbol',
		})
			.formatToParts(0)
			.find(part => part.type === 'currency')?.value || currency
	);
}

async function setLanguage(locale: string): Promise<void> {
	await i18next.changeLanguage(locale);
}

export default {
	formatCurrency,
	formatNumber,
	getCurrencySymbol,
	parseAmount,
	setLanguage,
	i18next,
};
